module.exports = __webpack_public_path__ + "static/media/002-girl.bbdfeb96.svg";